var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSketchLogo = function SvgIconSketchLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.997 3.092a1 1 0 0 1 .753-.342h10.5a1 1 0 0 1 .753.341l5.25 6a1 1 0 0 1-.022 1.341l-10.5 11.25a1 1 0 0 1-1.462 0l-10.5-11.25a1 1 0 0 1-.022-1.34zM9.972 4.75H7.204l-3.5 4h3.2zm-3.246 6H3.8l5.207 5.58zm8.266 5.579 5.207-5.579h-2.925zm.121-5.579H8.888L12 18.36zm-.537-2H9.424L12 5.393zm2.52 0-3.068-4h2.768l3.5 4z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSketchLogo;